'use client';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import Icon from '@/components/ui/AppIcon';

interface EGiftForm {
  recipient: string;
  amount: string;
  message: string;
}

export default function EGiftSection() {
  const [sending, setSending] = useState(false);
  const { register, handleSubmit, formState: { errors }, reset } = useForm<EGiftForm>();

  function onSubmit(data: EGiftForm) {
    setSending(true);
    // Backend integration: POST /api/egift/send with recipient, amount, message
    setTimeout(() => {
      setSending(false);
      reset();
      toast.success('eHediye gönderildi! 🎁', { description: `${data.recipient} adresine ₺${data.amount} hediye kartı gönderildi` });
    }, 1500);
  }

  return (
    <div>
      <div className="bg-card rounded-2xl p-5 card-shadow">
        <div className="flex items-center gap-3 mb-4">
          <div className="w-10 h-10 rounded-2xl bg-gold-light flex items-center justify-center">
            <Icon name="GiftIcon" size={20} variant="solid" className="text-gold" />
          </div>
          <div>
            <h3 className="text-foreground font-bold text-base">eHediye Gönder</h3>
            <p className="text-muted-foreground text-xs">Sevdiklerinize Gloria Jean's hediye et</p>
          </div>
        </div>

        <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
          <div>
            <label className="block text-foreground text-sm font-semibold mb-1">
              Alıcı E-posta veya Telefon
            </label>
            <input
              type="text"
              placeholder="ornek@email.com veya 05XX XXX XX XX"
              className="w-full bg-input border border-border rounded-xl px-4 py-3 text-foreground text-sm placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/30"
              {...register('recipient', { required: 'Alıcı bilgisi gereklidir' })}
            />
            {errors.recipient && <p className="text-red-500 text-xs mt-1">{errors.recipient.message}</p>}
          </div>

          <div>
            <label className="block text-foreground text-sm font-semibold mb-1">Miktar</label>
            <div className="grid grid-cols-4 gap-2">
              {['25', '50', '100', '150'].map((amt) => (
                <label key={`egift-amt-${amt}`} className="cursor-pointer">
                  <input type="radio" value={amt} className="sr-only" {...register('amount', { required: true })} />
                  <div className="py-2 rounded-xl border text-center text-sm font-bold transition-all border-border hover:border-primary/50">
                    ₺{amt}
                  </div>
                </label>
              ))}
            </div>
            {errors.amount && <p className="text-red-500 text-xs mt-1">Miktar seçiniz</p>}
          </div>

          <div>
            <label className="block text-foreground text-sm font-semibold mb-1">
              Kişisel Mesaj <span className="text-muted-foreground font-normal">(isteğe bağlı)</span>
            </label>
            <textarea
              rows={3}
              placeholder="Güzel bir mesaj yazın..."
              className="w-full bg-input border border-border rounded-xl px-4 py-3 text-foreground text-sm placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/30 resize-none"
              {...register('message')}
            />
          </div>

          <button
            type="submit"
            disabled={sending}
            className="w-full bg-primary text-white font-bold py-4 rounded-2xl flex items-center justify-center gap-2 hover:bg-primary/90 transition-colors active:scale-[0.98] disabled:opacity-70"
          >
            {sending ? (
              <>
                <svg className="animate-spin w-5 h-5" viewBox="0 0 24 24" fill="none">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
                </svg>
                <span>Gönderiliyor...</span>
              </>
            ) : (
              <>
                <Icon name="GiftIcon" size={18} className="text-white" />
                <span>eHediye Gönder</span>
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
}